export default __webpack_public_path__ + "static/invimatic-iso-more-news-2-076f847c28c3f0fa7434c01eb2ea4fc7.png";